import {DocumentHandler} from "../document-handler";

/**
 * Handler for inline collapsible text elements, which toggle between
 * a collapsed and expanded state when clicked.
 *
 * Inline collapsibles are generated by Quarkdown's `.textcollapse` and by error messages.
 */
export class InlineCollapsibles extends DocumentHandler {
    async onPostRendering() {
        // Add click event listener to the collapsible spans.
        const collapsibles = document.querySelectorAll<HTMLElement>('.inline-collapse');
        collapsibles.forEach((span) => {
            span.addEventListener('click', () => this.toggleCollapse(span));
        });
    }

    private toggleCollapse(span: HTMLElement) {
        const fullText = span.dataset.fullText;
        const collapsedText = span.dataset.collapsedText;
        const collapsed = span.dataset.collapsed === 'true';

        // Toggle between the full and collapsed text.
        const content = collapsed ? fullText : collapsedText;
        if (!content) return;

        span.dataset.collapsed = (!collapsed).toString();

        const isUserDefined = span.closest('.error') === null;
        if (isUserDefined) {
            span.innerHTML = content;
        } else {
            span.textContent = content;
        }
    }
}